import React, { Component } from 'react';
import styled from 'styled-components';
import Header from '../shared/Header';
import {
  Column,
  Title,
  Subtitle,
  Button,
  StyledSelect,
  Label,
  StyledRow,
  Form,
  Text,
} from '../theme/index';
import { Formik } from 'formik';
import { getOptions, getNurseOptions } from '../../fixture/data';
import { Link } from 'react-scroll';
import ImageLoader from '../shared/ImageLoader';

const StyledColumn = styled(Column)`
  align-items: center;
  text-align: ${props => props.textalign};
  width: 75%;
  margin: 0 auto;
  padding: 1em 0;
  @media (max-width: 400px) {
    width: 90%;
  }
`;

const Div = styled.div`
  border: 1px solid #ffaf77;
  height: 0.5px;
  width: 20%;
  background-color: #ffaf77;
  margin: 0 auto;
`;

export default class Splash extends Component {
  state = {
    profession: [{ label: 'Select a state first', value: null }],
  };

  isAuthenticated = () => {
    return localStorage.getItem('authorization');
  };

  render() {
    const {
      img,
      id,
      text,
      navigate,
      price,
      formatPrice,
      handleSubmit,
      children,
    } = this.props;

    return (
      // <Wrapper
      //   background={img && `url('${img}')`}
      //   height={id === "profession" || "course" ? "650px" : "800px"}
      // >
      <ImageLoader src={img} id={id}>
        <Header />
        <StyledColumn textalign={id === 'home' ? 'left' : 'center'}>
          {id === 'profession' && (
            <StyledRow
              style={{ cursor: 'pointer' }}
              alignitems="center"
              onClick={handleSubmit}
            >
              <i
                style={{
                  color: '#fff',
                  fontSize: '1.6em',
                  marginRight: '.5em',
                }}
                className="fas fa-angle-left"
              />
              <Text white>Change state or profession</Text>
            </StyledRow>
          )}
          <Title white>{text && text[0]}</Title>

          {id === 'profession' && <Div />}
          {id === 'thanks' && <Title white>Thanks!</Title>}
          <Subtitle findce={id === 'findce'}>{text && text[1]}</Subtitle>
          {id === 'course' && (
            <Button buy onClick={handleSubmit}>{`Buy $${formatPrice(
              price
            )}`}</Button>
          )}
          {id === 'thanks' && (
            <Subtitle>Someone from our team will be in contact soon.</Subtitle>
          )}
          {id === 'noMatch' && (
            <div>
              <Subtitle>Oops! This page does not exist.</Subtitle>
            </div>
          )}
          {(id === 'home' || id === 'nursing') && (
            <Formik
              initialValues={{ state: '', profession: '' }}
              onSubmit={values => {
                let state = values.state.label.replace(/\s+/g, '-');
                let profession = values.profession.label.replace(/\s+/g, '-');
                navigate.push(`${profession}/${state.trim()}`);
              }}
              render={({ values, handleBlur, handleSubmit, setFieldValue }) => (
                <Form onSubmit={handleSubmit}>
                  <StyledRow>
                    <Label htmlFor="state">
                      <StyledSelect
                        required
                        type="state"
                        id="state"
                        placeholder="State"
                        options={
                          id === 'nursing'
                            ? getNurseOptions('state')
                            : getOptions('state')
                        }
                        onChange={value => {
                          setFieldValue('state', value);
                          this.setState({
                            profession:
                              id === 'nursing'
                                ? getNurseOptions('profession', value)
                                : getOptions('profession', value),
                          });
                        }}
                        onBlur={handleBlur}
                        value={values.state}
                      />
                    </Label>
                    <Label htmlFor="profession">
                      <StyledSelect
                        required
                        type="profession"
                        id="profession"
                        placeholder="Profession"
                        options={this.state.profession}
                        onChange={value => {
                          setFieldValue('profession', value);
                        }}
                        onBlur={handleBlur}
                        value={values.profession}
                      />
                    </Label>
                  </StyledRow>
                  <Button home type="submit">
                    Find your ce
                  </Button>
                </Form>
              )}
            />
          )}
          {id === 'profession' && (
            <Link
              to="courses"
              activeClass="active"
              className="test1"
              spy={true}
              smooth={true}
              duration={500}
            >
              <Button>Skip to courses</Button>
            </Link>
          )}
        </StyledColumn>
        {children}
      </ImageLoader>
      // </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/Splash.jsx